export function isMobile() {
  const userAgent = navigator.userAgent.toLowerCase()
  const _isMobile = /Android|iPhone|iPad/i.test(userAgent) || (/Harmony/i.test(userAgent) && /Mobile/i.test(userAgent))

  // 检测触摸屏设备（增强平板识别）
  const isTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0

  // 特殊处理iPad：iPadOS 13+的UA包含Macintosh但支持触摸
  const isiPad = /Macintosh/i.test(userAgent) && isTouchScreen

  return _isMobile || isiPad
}

export function isPC() {
  return !isMobile();
}